export class RefundRequestRequestData {
    from_date: string;
    to_date: string;
}
export class RefundRequest {
   

    merchant_trnx_id: string;
	ekpay_trnx_id: string;
	amount: string;
	requested_on: string;
    refunded_on: string;
	status: string;
    action: string;
}
export class RefundRequestView {
    status: string;
    message: string;
    data: RefundRequest[];
}
export class RefundRequestUpdateStatusRequest {
   
    ekpay_trnx_id: string;
	status: string;

}

export class RefundRequestUpdateStatusResponse {
   
	status: string;
    message: string;

}


// WEBPACK FOOTER //
// ./src/app/report/refund-request/refund-request.ts